import firebase from "firebase";
var db = firebase.firestore();
var contactRef = db.collection("contactsV2");
var permissionRef = db.collection("permissions");
import _ from "underscore";

export default {
  add: async function(permission) {
    let permissionGroup = await this.getNamed(permission.name);
    if (permissionGroup.length > 0) {
      return { error: "A permission with that name already exists" };
    } else {
      return permissionRef.add(permission).then((docRef) => {
        return docRef;
      });
    }
  },
  update: function(permission) {
    var docRef = permissionRef.doc(permission.id);

    return docRef
      .update({
        name: permission.name,
        organizations: permission.organizations,
        roles: permission.roles,
      })
      .then(() => {
        return "Document successfully updated!";
      })
      .catch((error) => {
        console.log("Error getting cached document:", error);
      });
  },
  delete: function(id) {
    return permissionRef
      .doc(id)
      .delete()
      .then(() => {
        return "Document successfully deleted!";
      })
      .catch((error) => {
        return "Error removing document: " + error;
      });
  },
  get: async function(id) {
    return permissionRef
      .get(id)
      .then((querySnapshot) => {
        let _permission = [];
        querySnapshot.forEach((doc) => {
          let permission = doc.data();
          permission.id = doc.id;
          _permission.push(permission);
        });
        return _permission; // returns array of contacts
      })
      .catch((error) => {
        console.log("getAll() error: ", error);
      });
  },
  getNamed: async function(name) {
    return permissionRef
      .where("name", "==", name)
      .get()
      .then((querySnapshot) => {
        let _permission = [];
        querySnapshot.forEach((doc) => {
          let permission = doc.data();
          permission.id = doc.id;
          _permission.push(permission);
        });
        return _permission; // returns array of contacts
      })
      .catch((error) => {
        console.log("getAll() error: ", error);
      });
  },
  getSorted: async function(id) {
    var docRef = permissionRef.doc(id);
    return docRef
      .get()
      .then((doc) => {
        let _permission = doc.data();
        var perChunk = 5;
        let organizations = _permission.organizations.reduce(
          (resultArray, item, index) => {
            const chunkIndex = Math.floor(index / perChunk);
            if (!resultArray[chunkIndex]) {
              resultArray[chunkIndex] = [];
            }
            resultArray[chunkIndex].push(item);

            return resultArray;
          },
          []
        );

        let roles = _permission.roles.reduce((resultArray, item, index) => {
          const chunkIndex = Math.floor(index / perChunk);
          if (!resultArray[chunkIndex]) {
            resultArray[chunkIndex] = [];
          }
          resultArray[chunkIndex].push(item);

          return resultArray;
        }, []);

        return {
          name: _permission.name,
          organizations: organizations,
          roles: roles,
          id: doc.id,
        }; // returns array of _permission
      })
      .catch((error) => {
        console.log("Error getting cached document:", error);
      });
  },
  getAll: async function() {
    return permissionRef
      .get()
      .then((querySnapshot) => {
        let _permission = [];
        querySnapshot.forEach((doc) => {
          let permission = doc.data();
          permission.id = doc.id;
          _permission.push(permission);
        });

        _permission.sort((a, b) => {
          return a.name.localeCompare(b.name);
        });

        return _permission; // returns array of contacts
      })
      .catch((error) => {
        console.log("getAll() error: ", error);
      });
  },
  getOrganizations: async function() {
    return contactRef
      .get()
      .then((querySnapshot) => {
        let _contacts = [];
        querySnapshot.forEach((doc) => {
          let contact = doc.data();
          contact["contact_uid"] = doc.id; // store doc.id as contact_uid
          _contacts.push(contact); // push to temp array
          //console.log(doc.id, " => ", doc.data());
        });

        let orgArray = _.uniq(_contacts, (x) => x.Organization).map(function(
          el
        ) {
          return { organization: el.Organization, selected: false };
        });

        orgArray = orgArray.filter((item) => item.organization);

        orgArray.sort((a, b) => {
          return a.organization.localeCompare(b.organization);
        });

        var perChunk = 5; // items per chunk
        var inputArray = orgArray;
        return inputArray.reduce((resultArray, item, index) => {
          const chunkIndex = Math.floor(index / perChunk);
          if (!resultArray[chunkIndex]) {
            resultArray[chunkIndex] = [];
          }
          resultArray[chunkIndex].push(item);

          return resultArray;
        }, []);
      })
      .catch((error) => {
        console.log("getContacts() error: ", error);
      });
  },
  getRoles: async function() {
    return contactRef
      .get()
      .then((querySnapshot) => {
        let _contacts = [];
        querySnapshot.forEach((doc) => {
          let contact = doc.data();
          contact["contact_uid"] = doc.id; // store doc.id as contact_uid
          _contacts.push(contact); // push to temp array
          //console.log(doc.id, " => ", doc.data());
        });

        let orgArray = _.uniq(_contacts, (x) => x.Role).map(function(el) {
          return { role: el.Role, selected: false };
        });

        orgArray = orgArray.filter((item) => item.role);

        orgArray.sort((a, b) => {
          return a.role.localeCompare(b.role);
        });

        var perChunk = 5; // items per chunk
        var inputArray = orgArray;

        return inputArray.reduce((resultArray, item, index) => {
          const chunkIndex = Math.floor(index / perChunk);

          if (!resultArray[chunkIndex]) {
            resultArray[chunkIndex] = [];
          }

          resultArray[chunkIndex].push(item);

          return resultArray;
        }, []);
      })
      .catch((error) => {
        console.log("getContacts() error: ", error);
      });
  },
};
